// Modules
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdJoinApi, AdJoinStatusApi, JoinSgApi } from "_Route/Api";


const AdJoinDt = () => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // State
  const useGroup = ['진행중', '합격', '모집 종료', '불합격']; // 지원 상태 배열

  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);

  const sessionID = localStorage.getItem('memSessionID')
  const [joinData, setJoinData] = useState([]);
  const [info, setInfo] = useState({ // 전체 Data 배열 
    join_status: '',
    approve_spec_status: 0,
    approve_ap_status: 0,
  })
  const { join_status } = info;
  

  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  // onChange Info
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: Number(value)});
  }


  /*========================================================================
  * Set Current Join List
  ========================================================================*/
  useEffect(() => {
    axios.get(JoinSgApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        join_uuid: params.id
      }
    })
    .then(res => {
      const curJoin = res.data.result[0]
      setJoinData(curJoin);
      if(curJoin === undefined) {
        navigate('/404');
      }
      setInfo({
        ...info,
        join_status: curJoin.join_status,
        approve_spec_status: 0,
        approve_ap_status: 0,
      })
    })
    .catch(err => {
      console.error(err, "GET Join Data Error...");
    })
  }, [location])


  /*========================================================================
  * Join Axios 
  ========================================================================*/
  const updateJoin = () => { // Join 수정
    const tempInfo = info;
    tempInfo.join_uuid = params.id

    axios({
      url: AdJoinStatusApi,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: tempInfo
    })
    .then(res => {
      alert(`지원자 수정${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/dev-employ/join/list')
    })
    .catch(err => {
      console.error(err, "Join PUT Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const deleteJoin = () => { // Join 삭제
    axios({
      url: AdJoinApi,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        join_uuid: params.id,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`지원자 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      navigate('/admin/dev-employ/join/list')
    })
    .catch(err => {
      console.error(err, "Join DELETE Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }


  return (
    <>
      <div className="adContTitGroup">
        <h2>지원자 수정</h2>
        <p>Home / 개발자 채용 / 지원자 수정</p>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>채용 글 수정</legend>

          {/* 지원 상태 [join_status] */}
          <div className="fieldGroup row">
            <label>지원 상태<span className="redTxt">*</span></label>

            <div className="field">
              {useGroup.map((item, i) =>
                <div className="checkGroup" key={i}>
                  <input type="radio" className="check sm blue" name="join_status" id={`join_status_${i}`} value={i} onChange={(e) => onChange(e)} checked={Number(join_status) === i}/>
                  <label htmlFor={`join_status_${i}`}></label>

                  <label htmlFor={`join_status_${i}`}>{item}</label>
                </div>
              )}
            </div>
          </div> 
  
          {/* 지원 글 제목 [join_title] */}
          <div className="fieldGroup row">
            <label>지원 글 제목</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={joinData.join_title || ''} disabled />
            </div>
          </div>
          
          {/* 지원 글 내용 [join_content] */}
          <div className="fieldGroup row">
            <label>지원 글 내용</label>

            <div className="field full">
              <textarea type="text" className="textarea md round" value={joinData.join_content || ''} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          {
            userScore >= 300 &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={() => updateJoin()}>{`수정${master === 1 ? '' : ' 요청'}`}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/dev-employ/join/list')}>취소</button>
          { userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => {if(window.confirm(`정말 해당 지원자를 삭제${master === 1 ? '' : ' 요청'}하시겠습니까?`)) deleteJoin() }}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
        </div>
      </div>
    </>
  )
}

export default AdJoinDt;